import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useCoreApi } from '../api';
import { useUserData } from '../user/users';
import { User } from '../user/users.types';

export function useEditUserInfo() {
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();

  const editUser = async (editInfoObject: { user: Partial<User> }) => {
    const { data } = await CoreApi.put(`/user/info`, editInfoObject);
    return data;
  };

  return useMutation({
    mutationFn: editUser,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['user'],
      });
    },
  });
}

// React Query: doc: Update data on success without invalidating query data...
export function useEditUserImage() {
  const { data: user } = useUserData();
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();

  const editUserImage = async (userImage: File) => {
    if (!user) return false;

    const imageRequestObject = new FormData();
    imageRequestObject.append('file', userImage);
    imageRequestObject.append('object', 'users');
    imageRequestObject.append('uuid', user.uuid);

    const { data } = await CoreApi.post(`/logos/users/${user.uuid}`, imageRequestObject);
    return data;
  };

  return useMutation({
    mutationFn: editUserImage,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['user'],
      });
    },
  });
}
